import { ApiResponse, BaseCreateResponse, BaseResponse, baseUrl, deleteWithAuth, getWithAuth, Guid, ListRespone, patchWithAuth, postWithAuth } from "./baseApi";

export type Organisation = {
    id: Guid,
    name: string,
    createDate: string
}

export type CreateOrganisationRequest = {
    name: string
}

export const getOrganisationsList = async(): Promise<ApiResponse<ListRespone<Organisation>>> => {
    return await getWithAuth<ListRespone<Organisation>>({url: `${baseUrl}organisations`});
}

export const createOrganisation = async(request: CreateOrganisationRequest): Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<CreateOrganisationRequest, BaseCreateResponse>(`${baseUrl}organisations`, request);
}

export const updateOrganisation = async(id: Guid, request: CreateOrganisationRequest): Promise<ApiResponse<BaseResponse>> => {
    return await patchWithAuth<CreateOrganisationRequest, BaseResponse>(`${baseUrl}organisations/${id}`, request);
}

export const deleteOrganisation = async(id: Guid): Promise<ApiResponse<BaseResponse>> => {
    return await deleteWithAuth<BaseResponse>(`${baseUrl}organisations`, id);
}
